import { ReduxService } from 'dashboard-services/services';

import { basicPipelineCreatorActions, builderPipelineCreatorActions } from 'actions/modules/datascience';

export const basicInitialState = {
  categories: [],
  id: undefined,
  tasks: {},

  saved: false,
  executing: false,
  paused: false,
  lastStatus: {},
  pausedEditedFiles: [],
  statuses: [],

  commentsVisible: true,

  dynamicParameters: [],

  footerExpanded: false,
  addTaskExpanded: false,
  showAdditional: false,
  statusVersion: -1,

  zIndexStack: [],

  isOpenExportMissingTaskDef: false,
  isOpenExportVersionMissMatch: false,
  exportMissingTaskDefs: [],
  onSubmitExportVersionMissMatch: undefined
}

export default (state = basicInitialState, action) => {
  switch (action.type) {
    case basicPipelineCreatorActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case basicPipelineCreatorActions.SET_PIPELINE_ID:
      return ReduxService.updateObject(state, { id: action.id, saved: true })
    case basicPipelineCreatorActions.GET_TASKS_FOR_CATEGORY:
      return ReduxService.updateObject(state, { tasks: ReduxService.updateObject(state.tasks, { [action.category]: action.tasks }) })
    case basicPipelineCreatorActions.ADD_TASKS_TO_CATEGORIES: {
      let stateTasks = ReduxService.updateObject(state.tasks || {}, {});
      (action.tasks || []).forEach(task => {
        const exist = stateTasks[task.category]?.findIndex(taskInState => taskInState.id === task.id) || -1
        if(exist === -1) {
          stateTasks = ReduxService.updateObject(stateTasks, { [task.category]: (stateTasks?.[task.category] || []).add(task) })
        }
      })
      return ReduxService.updateObject(state, { tasks: stateTasks })
    }
    case basicPipelineCreatorActions.CLEAN_ALL:
      return ReduxService.updateObject(basicInitialState, { categories: state.categories, tasks: state.tasks });
    case builderPipelineCreatorActions.ADD_TASK:
    case builderPipelineCreatorActions.CONNECT_TASKS:
    case builderPipelineCreatorActions.DISCONNECT_TASKS:
    case builderPipelineCreatorActions.REMOVE_TASK:
    case builderPipelineCreatorActions.ADD_COMMENT:
    case builderPipelineCreatorActions.REMOVE_COMMENT:
    case builderPipelineCreatorActions.CHANGE_COMMENT:
    case builderPipelineCreatorActions.CHANGE_TASK_PROP:
    case builderPipelineCreatorActions.CHANGE_TASK_PARAM:
      return ReduxService.updateObject(state, { saved: false })
    case basicPipelineCreatorActions.SET_SAVED:
      return ReduxService.updateObject(state, { saved: action.value })
    case basicPipelineCreatorActions.SET_EXECUTING: {
      if(action.executing !== state.executing) {
        return ReduxService.updateObject(state, { executing: action.executing })
      }
      return state;
    }
    case basicPipelineCreatorActions.SET_PAUSED: {
      if(action.paused !== state.paused) {
        return ReduxService.updateObject(state, { paused: action.paused })
      }
      return state;
    }
    case basicPipelineCreatorActions.SET_STATUSES: {
      if(JSON.stringify(action.items) !== JSON.stringify(state.statuses)) {
        return ReduxService.updateObject(state, { statuses: action.items })
      }
      return state;
    }
    case basicPipelineCreatorActions.SET_COMMENTS_VISIBLE:
      return ReduxService.updateObject(state, { commentsVisible: action.value })
    case basicPipelineCreatorActions.SET_FOOTER_EXPANDED:
      return ReduxService.updateObject(state, { footerExpanded: action.value })
    case basicPipelineCreatorActions.SET_ADD_TASK_EXPANDED:
      return ReduxService.updateObject(state, { addTaskExpanded: action.value })
    case basicPipelineCreatorActions.SET_STATUS_VERSION:
      return ReduxService.updateObject(state, { statusVersion: action.value })
    case basicPipelineCreatorActions.BRING_TO_FRONT:
      return ReduxService.updateObject(state, { zIndexStack: state.zIndexStack.filter(name => name !== action.value).add(action.value) })
    case basicPipelineCreatorActions.SET_PAUSED_EDITED_FILES:
      return ReduxService.updateObject(state, { pausedEditedFiles: action.value })
    case basicPipelineCreatorActions.ADD_PAUSED_EDITED_FILE:
      return ReduxService.updateObject(state, { pausedEditedFiles: (state.pausedEditedFiles || []).add(action.value) })
    default:
      return state; 
  }
}